import { Box } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';

export interface PaloTableViewportProps {
    /** How many rows the table holds. */
    rows: number;
    /** Roughly how tall one row is. */
    rowHeight?: number;
    /** How many rows are shown before the table scrolls on its own. */
    maxRows?: number;
    /** How tall the fixed header row is. */
    headerHeight?: number;
}

/**
 * A height for a virtual table inside the detail body.
 *
 * Form and history share one scroll area there, so the form area has no height
 * of its own. A virtual table asked for all of it collapses to nothing and
 * draws no row at all — the header stands there and the list underneath is
 * empty, whatever the document holds.
 *
 * So the table gets a viewport as tall as its content, capped: a long list
 * scrolls inside the table instead of pushing the history out of reach.
 */
export const PaloTableViewport = ({
    rows,
    rowHeight = 48,
    maxRows = 12,
    headerHeight = 34,
    children,
}: PropsWithChildren<PaloTableViewportProps>): ReactElement => (
    <Box sx={{ height: Math.min(Math.max(rows, 1), maxRows) * rowHeight + headerHeight, flexShrink: 0 }}>
        {children}
    </Box>
);
